import React from 'react';
const BG_IMAGE = 'https://cdn.magicpatterns.com/uploads/sggVRKgYVXrcpAc3ebnLKR/322943F7-8D42-41CA-8906-9162A57E4A4E.png';
/**
 * Hero backdrop — the uploaded rack-above-the-earth image rendered as-is,
 * with only a bottom fade so the hero dissolves into the next section.
 */
export function HeroBackground() {
  return <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden bg-black" data-id="element-127">
      <img src={BG_IMAGE} alt="" className="absolute inset-0 h-full w-full object-cover object-[70%_center]" draggable={false} data-id="element-128" />
      {/* thin bottom-edge fade only — image stays untouched above it */}
      <div className="absolute inset-x-0 bottom-0 h-20 sm:h-24" style={{
      background: 'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.4) 55%, #000 100%)'
    }} data-id="element-129" />
    </div>;
}